import EventOutlinedIcon from 'components/material-symbol/icons/Event'
import InfoOutlinedIcon from 'components/material-symbol/icons/Info'
import CheckIcon from 'components/material-symbol/icons/Check'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import {
  DetailField,
  DetailSection,
} from 'pages/pga-coach/students/student-show-page/details-components/content-box'
import { formatLeadIntent } from '../utils'

export default function LeadDetails({
  timeCreatedAt = 0,
  intent = '',
  contactMethod,
}) {
  const cleanedIntent = formatLeadIntent(intent)

  return (
    <DetailSection title="Lead details" compact stacked>
      <DetailField
        icon={EventOutlinedIcon}
        label="Submitted"
        value={
          timeCreatedAt
            ? `${formatDistanceToNow(Date.parse(timeCreatedAt))} ago`
            : 'N/A'
        }
      />
      {cleanedIntent ? (
        <DetailField
          icon={InfoOutlinedIcon}
          label="Interest"
          value={cleanedIntent}
        />
      ) : null}
      {contactMethod ? (
        <DetailField
          icon={CheckIcon}
          label="Contact method"
          value={contactMethod}
        />
      ) : null}
    </DetailSection>
  )
}
